export const messages: Record<string, string> = {
    '11000': 'User Not found',
    '10005': 'Mobile number already exist',
    '10007': 'Invalid OTP',
    '10008': 'NRIC/FIN already exist',
    '30001': 'No attendance record found on this service date',
    '30002': 'Invalid attendance record found on this service date',
    '30003': 'Failed to get the salary info. Kindly update it before submitting the claim',
    '30004': "There's a loan record on this service date",
    '30005': "Failed to get the salary type. Kindly update it before submitting the claim"
}
